var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('n-dialog',{staticClass:"system-messaging",attrs:{"persistent":_vm.persistent},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[(_vm.category && !_vm.category.isEmpty)?_c('n-ordering-menu-tile',{staticClass:"fill-height",attrs:{"data":_vm.category}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }